import { Link, TableCell } from '@amzn/meridian';
import type { LdapPermissionRowLdapGroupNameCellDataFragment } from 'generated/graphql';
import type { FC } from 'react';

export type LDAPPermissionRowLDAPGroupNameCellProps = {
  ldapData: LdapPermissionRowLdapGroupNameCellDataFragment;
};

export const LDAPPermissionRowLDAPGroupNameCell: FC<LDAPPermissionRowLDAPGroupNameCellProps> = ({ ldapData }) => (
  <TableCell>
    <Link href={`https://permissions.amazon.com/group.mhtml?group=${ldapData.ldapGroup}&group_type=ldap`} target="_blank">
      {ldapData.ldapGroup}
    </Link>
  </TableCell>
);
